@if(false){
<!-- 🔹 Monthly Report 1 - Maintenance Notice -->
<div class="min-h-[500px] flex items-center justify-center">
  <div class="w-full">
    <div
      class="bg-white/60 dark:bg-slate-800/60 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-white/20 dark:border-slate-700/50 text-center">
      <div
        class="mx-auto flex items-center justify-center w-16 h-16 bg-orange-100 dark:bg-orange-900/30 rounded-full mb-6">
        <svg class="w-8 h-8 text-orange-600 dark:text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z">
          </path>
        </svg>
      </div>
      <h1 class="text-3xl font-bold text-slate-900 dark:text-slate-100 mb-3">
        Monthly Report - Business Analytics
      </h1>
      <p class="text-lg text-slate-600 dark:text-slate-300 mb-6">
        We're currently experiencing some technical difficulties
      </p>
      <div
        class="bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-xl p-6 mb-6">
        <h3 class="text-xl font-semibold text-orange-800 dark:text-orange-200 mb-2">
          Service Temporarily Unavailable
        </h3>
        <p class="text-orange-700 dark:text-orange-300 leading-relaxed">
          We're facing some issues with our service. The team is working to
          resolve this quickly. Please try again after some time.
        </p>
      </div>
      <div class="mt-8 pt-6 border-t border-slate-200 dark:border-slate-700">
        <p class="text-sm text-slate-500 dark:text-slate-400">
          Issue ID: #{{ issueId }} | Last updated: {{ currentTimestamp }} |
          Status: Under Maintenance
        </p>
      </div>
    </div>
  </div>
</div>
}

<ng-container>
  <div [class.hidden]="!_breakpointService.isDesktop()">
    @if (!mixedMode()) {
    <ai-headlines class="block mb-4"></ai-headlines>
    }
    <div class="card-bg p-4 rounded-xl">

      <!-- 🔹 Header — hidden in embedded (`mixedMode`) mode because the parent
         (e.g. My Dashboard) provides its own section title + chrome, and the
         date-picker / Ask Prism AI / Customize Layout actions don't apply
         when the user is just previewing pinned widgets. -->
      @if (!mixedMode()) {
      <div class="flex flex-col justify-between gap-4 items-start mb-4 z-[99]"
        [ngClass]="{'lg:flex-row lg:items-center': !_commonService.isPanelOpen()}">

        <div class="flex items-center justify-between"
          [ngClass]="{'w-full': _commonService.isPanelOpen(), 'w-auto': !_commonService.isPanelOpen()}">
          <h1 class="text-2xl font-medium text-[#141437] dark:text-white">
            Business Analytics Monthly
          </h1>
        </div>

        <div class="flex items-center gap-3 flex-wrap"
          [ngClass]="{'w-full justify-end': _commonService.isPanelOpen(), 'lg:w-auto': !_commonService.isPanelOpen()}">

          <app-date-picker [size]="'md'" (valueChange)="rangeValues($event)"
            (dateRangeChange)="onDateRangeChange($event)" [showComparison]="true" [showGroupBy]="true">
          </app-date-picker>

          @if (isDenefits()) {
          <button (click)="openAiAssistant(true)"
            class="gradient-border text-[#141437] dark:text-white text-sm lg:text-xs font-medium px-5 lg:px-3 py-2.5 lg:py-3 rounded-lg transition-all duration-200 shadow-[0px_6px_12px_-6px_#AD46FF] hover:shadow-[0px_7px_12px_-5px_#AD46FF] flex items-center gap-2 disabled:opacity-50 cursor-pointer disabled:cursor-not-allowed">
            <app-icon name="sparkles" [size]="16" />
            Ask Prism AI
          </button>
          }

          <!-- 🔹 Add Hidden Section Button -->
          @if (hiddenDashboardCards().length > 0) {
          <div class="relative">
            @if (isAddSectionMenuOpen()) {
            <div class="fixed inset-0 z-40" (click)="isAddSectionMenuOpen.set(false)"></div>
            <div
              class="absolute right-0 mt-2 w-72 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 z-50 overflow-hidden">
              <div
                class="bg-slate-50 dark:bg-slate-700/50 p-3 border-b border-slate-100 dark:border-slate-700 font-semibold text-sm text-slate-600 dark:text-slate-300">
                Hidden Sections
              </div>
              <div class="max-h-72 overflow-y-auto p-2">
                @for (hiddenCard of hiddenDashboardCards(); track hiddenCard.id) {
                <div
                  class="flex items-center justify-between p-2 hover:bg-slate-50 dark:hover:bg-slate-700/50 rounded-lg group cursor-default">
                  <div class="flex items-center gap-3">
                    <div
                      class="bg-slate-100 dark:bg-slate-700 p-2 rounded-md text-slate-500 dark:text-slate-400 group-hover:text-blue-500 group-hover:bg-blue-50 dark:group-hover:bg-blue-900/30 transition-colors">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect width="7" height="7" x="3" y="3" rx="1" />
                        <rect width="7" height="7" x="14" y="3" rx="1" />
                        <rect width="7" height="7" x="14" y="14" rx="1" />
                        <rect width="7" height="7" x="3" y="14" rx="1" />
                      </svg>
                    </div>
                    <p class="text-sm font-medium text-slate-700 dark:text-slate-300">{{ getCardTitle(hiddenCard) }}</p>
                  </div>
                  <button (click)="toggleDashboardCardVisibility(hiddenCard); isAddSectionMenuOpen.set(false)"
                    class="p-1.5 text-slate-400 hover:text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/30 rounded-md transition-colors"
                    title="Show section">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M5 12h14" />
                      <path d="M12 5v14" />
                    </svg>
                  </button>
                </div>
                }
              </div>
            </div>
            }
          </div>
          }

          <!-- Customize Layout Button -->
          <button (click)="openCustomizeLayout()"
            class="flex items-center gap-1.5 px-3 py-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm font-medium hover:border-[#AD46FF]/60 hover:text-[#AD46FF] transition-all duration-200 shadow-sm whitespace-nowrap">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect width="7" height="7" x="3" y="3" rx="1" />
              <rect width="7" height="7" x="14" y="3" rx="1" />
              <rect width="7" height="7" x="14" y="14" rx="1" />
              <rect width="7" height="7" x="3" y="14" rx="1" />
            </svg>
            Customize layout
          </button>
        </div>
      </div>
      }



      <!--  Draggable Sections Grid  -->
      @if (filteredDashboardCards().length > 0) {
      <!-- Drag-drop on the main dashboard body has been disabled.. -->
      <div class="grid grid-cols-12 gap-4 grid-flow-row-dense mt-4">

        @for (card of filteredDashboardCards(); track trackDashboardCard($index, card)) {

        <!-- 🔹 "Business & Contracts Overall Analytics" section divider — rendered once before the first analytics card -->
        @if (isFirstAnalyticsCard(card)) {
        <div class="col-span-12 pt-2">
          <div class="text-xl font-medium text-[#141437] dark:text-white">
            Business &amp; Contracts Overall Analytics
          </div>
        </div>
        }

        <div [ngClass]="getSectionColClass(card)"
          class="group relative card-bg rounded-2xl shadow-sm transition-all duration-300 hover:shadow-md hover:border-[#AD46FF]/40 overflow-hidden">

          <!-- 🔹 Add to My Custom Dashboard quick action.
                 Floats above the card content (z-20) as a compact icon-only
                 pill so it never overlaps the card's own title, chart toggles,
                 or section header at rest. On hover/focus the pill morphs
                 open (max-width animates) to reveal the full label and the
                 toggle/remove affordance. The "Added" state is kept always
                 visible (color + check icon) but stays icon-sized at rest
                 to preserve the title area underneath.
                 Hidden when this report is embedded inside My Dashboard
                 (`[mixedMode]="true"`) — pinning is meaningless there. -->
          @if (card.widgetId > 0 && !mixedMode()) {
          <button type="button" (click)="addToCustomDashboard(card); $event.stopPropagation()"
            [disabled]="isAddingToCustomDashboard(card)"
            class="group/pin absolute cursor-pointer top-2 right-2 z-20 inline-flex items-center justify-center h-7 px-1.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap overflow-hidden opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
            [ngClass]="isAddedToCustomDashboard(card)
                  ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0'
                  : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
            [attr.aria-label]="isAddedToCustomDashboard(card) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
            [title]="isAddedToCustomDashboard(card) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
            @if (isAddingToCustomDashboard(card)) {
            <svg class="animate-spin shrink-0" xmlns="http://www.w3.org/2000/svg" width="12" height="12"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
              stroke-linejoin="round">
              <path d="M21 12a9 9 0 1 1-6.219-8.56" />
            </svg>
            <span
              class="inline-block max-w-0 group-hover/pin:max-w-[180px] focus-visible:max-w-[180px] overflow-hidden transition-[max-width] duration-300 ease-out">
              <span class="pl-1.5 pr-1">{{ isAddedToCustomDashboard(card) ? 'Removing' : 'Adding' }}&hellip;</span>
            </span>
            } @else if (isAddedToCustomDashboard(card)) {
            <!-- At rest: compact check pill (icon-only). On hover the same
                       pill expands and flips to a remove affordance (minus icon
                       + "Remove from Custom Dashboard") so the toggle action stays
                       discoverable without overlapping the card title at rest. -->
            <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="12" height="12"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"
              stroke-linejoin="round">
              <path d="M20 6 9 17l-5-5" />
            </svg>
            <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="12" height="12"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"
              stroke-linejoin="round">
              <path d="M5 12h14" />
            </svg>
            <span
              class="inline-block max-w-0 group-hover/pin:max-w-[200px] focus-visible:max-w-[200px] overflow-hidden transition-[max-width] duration-300 ease-out">
              <span class="pl-1.5 pr-1">Remove from Custom Dashboard</span>
            </span>
            } @else {
            <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
            <span
              class="inline-block max-w-0 group-hover/pin:max-w-[180px] focus-visible:max-w-[180px] overflow-hidden transition-[max-width] duration-300 ease-out">
              <span class="pl-1.5 pr-1">Pin to Custom Dashboard</span>
            </span>
            }
          </button>
          }

          <!-- 🔹 Section Content -->
          <div class="p-4">
            @switch (card.id) {

            <!-- MoM Active Businesses Chart -->
            @case (CardId.ACTIVE_BUSINESSES_MOM) {
            <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4">
              <h3 class="text-xl font-normal text-[#141437] dark:text-white">
                MoM Active Businesses
              </h3>
              <div class="flex items-center gap-2">
                <app-toggle-btns [headerOptions]="{
                          showlabels: true,
                          showIcon: true,
                          showToggleButton: true,
                          toggleOptions: tabOptions
                        }" (viewChanged)="setActiveTab($event)">
                </app-toggle-btns>
              </div>
            </div>
            <div class="flex flex-wrap gap-x-6 gap-y-2 text-sm mb-4">
              <div
                class="flex items-center gap-2 bg-[#EFF6FF] dark:bg-[#1A79F4] py-3 px-4 [@media(max-height:620px)]:py-2 [@media(max-height:620px)]:px-3 rounded-xl">
                <span class="text-[#38385B] dark:text-ink-soft">Active Businesses:</span>
                <span class="font-bold text-[#38385B] dark:text-white">{{ activeBusiness?.statsData?.total || 0
                  }}</span>
              </div>
              <div
                class="flex items-center gap-2 bg-[#FAF5FF] dark:bg-[#995BEF] py-3 px-4 [@media(max-height:620px)]:py-2 [@media(max-height:620px)]:px-3 rounded-xl">
                <span class="text-[#38385B] dark:text-ink-soft">Average Active Businesses:</span>
                <span class="font-bold text-[#38385B] dark:text-white">{{ activeBusiness?.statsData?.average_last_6
                  ||
                  0 }}</span>
              </div>
            </div>
            @if (view == 'lineChart') {
            <div class="h-[352px] [@media(max-height:620px)]:h-[260px] mt-10">
              @if( (activeBusiness?.chartData?.length ?? 0) > 0 || (activeBusiness?.previousChartData?.length ?? 0) >
              0){
              <app-line-chart [data1]="activeBusiness?.chartData || []"
                [data2]="activeBusiness?.previousChartData || []" [valueKey]="'value'" [unit]="unit()"
                [showYAxis]="true" [showXAxis]="true" [showXAxisGrid]="true" [xAxisShowOnlyFirstLast]="true"
                [showAllXticks]="false" [showAllXLabels]="false" [showCircleStrokes]="false" [showYAxisGrid]="false"
                [showYAxisPath]="true" [curveType]="'curveLinear'">
              </app-line-chart>
              }
              @if(activeBusiness?.chartData?.length == 0){
              <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
                <app-icon name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon>
                <p class="text-lg font-medium">No data available</p>
                <p class="text-sm mt-1">Data will appear here when available</p>
              </div>
              }
            </div>
            }
            @if (view == 'barChart') {
            <div class="w-full h-[352px] [@media(max-height:620px)]:h-[260px] mt-10">
              @if(activeBusiness?.chartData?.length > 0){
              <app-multiple-bar [data1]="activeBusiness?.chartData || []"
                [data2]="activeBusiness?.previousChartData || []" [valueKey]="'value'" [addGradient]="false"
                [barTextposition]="'top'" [barClusterPixel]="20" [tooltipData]="toolTipData"
                [showDynamicxAxisLabel]="true" [darkBarOutlineFill]="'#252558ba'" [lightBarOutlineFill]="'#F5F5F5'"
                [barClusterHeight]="60" [unit]="unit()" [colors]="colors" [xAxisShowOnlyFirstLast]="true"
                [showAllXticks]="false" [valueType]="'number'" [autoScrollOn3Years]="true">
              </app-multiple-bar>
              }
              @if(activeBusiness?.chartData?.length == 0){
              <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
                <p class="text-lg font-medium">No data available</p>
                <p class="text-sm mt-1">Data will appear here when available</p>
              </div>
              }
            </div>
            }
            @if(isSectionLoading('activeBusiness')){
            <app-individual-toaster></app-individual-toaster>
            }
            }
            <!-- Contract Types Overview -->
            @case (CardId.CONTRACT_TYPES_OVERVIEW) {
            <div class="h-[490px] [@media(max-height:620px)]:h-[360px] overflow-y-auto no-scrollbar">
              <div
                class="w-full flex items-center justify-between sticky top-0 z-10 bg-white dark:bg-surface-1 pb-3 mb-1">
                <h3 class="text-xl font-normal text-[#141437] dark:text-white">
                  Contract Types Overview
                </h3>
              </div>
              @if(!isSectionLoading('contractTypes')){
              <div class="min-h-[120px] grid grid-cols-1 2xl:grid-cols-2 gap-3">
                <div class="col-span-1" *ngFor="let contract of businessContractTypes; let i = index">
                  <div
                    class="flex justify-start flex-col items-start h-20 border border-slate-200 h-full dark:border-line p-4 bg-transparent rounded-2xl hover:border-[#ad46ff6e] hover:scale-[0.98] transition-all duration-300">
                    <div class="flex w-full gap-2">
                      <button [ngClass]="getRandomColor(i)"
                        class="p-2 w-9 h-9 rounded-xl flex justify-center items-center">
                        <app-icon [name]="'fileText'" [size]="20" class="text-white dark:text-black"></app-icon>
                      </button>
                      <div class="w-full flex flex-col gap-2">
                        <p class="m-0 text-[12px] font-medium text-[#38385B] dark:text-ink-soft">{{ contract.name }}
                        </p>
                        <div class="flex items-end">
                          <p class="m-0 text-lg font-medium text-[#141437] dark:text-white">{{ contract.value }}</p>
                          <span class="w-full text-[12px] flex items-center justify-end gap-2 font-medium" [ngClass]="{
                                    'text-[#15B268] dark:text-[#15B268]': contract.difference >= 0,
                                    'text-[#F05050] dark:text-[#F05050]': contract.difference < 0
                                  }">
                            <app-icon [name]="contract.difference >= 0 ? 'trendingUp' : 'trendingDown'"
                              [size]="16"></app-icon>
                            {{ contract.difference }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              }
              @if(isSectionLoading('contractTypes')){
              <div class="h-[120px]">
                <app-individual-toaster></app-individual-toaster>
              </div>
              }
            </div>
            }

            <!-- Top Categories by Contracts -->
            @case (CardId.TOP_CATEGORIES_BY_CONTRACTS) {
            <div class="flex justify-between items-center mb-4">
              <h3 class="text-xl font-normal text-[#141437] dark:text-white">
                Top Categories by Contracts
              </h3>
            </div>
            <div class="w-full overflow-y-auto hide-scrollbar">
              @if((topCategoriesChartData?.chartData?.length ?? 0) > 0){
              <app-horizontal-bar-chart [showXAxisLabel]="true" [showYAxisLabel]="true" [showBarsValue]="false"
                [showXAxisGrid]="true" [showYAxisGrid]="true" [leftMargin]="140"
                [data]="topCategoriesChartData.chartData">
              </app-horizontal-bar-chart>
              } @else {
              <div class="flex flex-col items-center justify-center h-[300px] text-gray-500">
                <app-icon name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon>
                <p class="text-lg font-medium">No data available</p>
                <p class="text-sm mt-1">Data will appear here when available</p>
              </div>
              }
            </div>
            @if(isSectionLoading('topCategories')){
            <app-individual-toaster></app-individual-toaster>
            }
            }

            <!-- Enrolled Businesses -->
            @case (CardId.ENROLLED_BUSINESSES) {
            <div class="flex justify-between items-center mb-4">
              <h3 class="text-xl font-normal text-[#141437] dark:text-white">Enrolled Businesses</h3>
              @if(isSectionLoading('enrolledBusiness')){
              <app-individual-toaster></app-individual-toaster>
              }
            </div>
            <div class="overflow-y-auto h-[220px]">
              @for(item of enrolledBusinessSignal(); track $index) {
              <div
                class="flex items-center justify-between rounded-lg p-3 mb-3 bg-[#F5F5F5] text-[#38385B] dark:bg-surface-3 dark:text-ink-soft hover:bg-[#E0E0E0] dark:hover:bg-line transition-colors cursor-pointer">
                <div>{{ item?.Country }}</div>
                <div>{{ item?.Enrolled ?? 0 }}</div>
              </div>
              }
              @if(enrolledBusinessSignal().length == 0) {
              <div class="flex flex-col items-center justify-center h-full py-6 text-gray-500">
                <app-icon name="inbox" [size]="48" class="text-gray-300 mb-3"></app-icon>
                <p class="text-base font-medium">No data available</p>
              </div>
              }
            </div>
            }

            <!-- Contracts Created -->
            @case (CardId.CONTRACTS_CREATED) {
            <div class="flex justify-between items-center mb-4">
              <h3 class="text-xl font-normal text-[#141437] dark:text-white">Contracts Created</h3>
            </div>
            <div class="overflow-y-auto h-[220px]">
              @for(item of regionalContractsSignal(); track $index) {
              <div
                class="flex items-center justify-between rounded-lg p-3 mb-3 bg-[#F5F5F5] text-[#38385B] dark:bg-surface-3 dark:text-ink-soft hover:bg-[#E0E0E0] dark:hover:bg-line transition-colors cursor-pointer">
                <div>{{ item?.Country }}</div>
                <div>{{ item?.ContractCreated ?? 0 }}</div>
              </div>
              }
              @if(regionalContractsSignal().length == 0) {
              <div class="flex flex-col items-center justify-center h-full py-6 text-gray-500">
                <app-icon name="inbox" [size]="48" class="text-gray-300 mb-3"></app-icon>
                <p class="text-base font-medium">No data available</p>
              </div>
              }
              @if(isSectionLoading('regionalContracts')){
              <app-individual-toaster></app-individual-toaster>
              }
            </div>
            }

            <!-- Overall Contract Type Count (Pie Chart) -->
            @case (CardId.OVERALL_CONTRACT_TYPE_COUNT) {
            <h3 class="text-xl font-normal text-[#141437] dark:text-white mb-4">
              Overall Contract Type Count
            </h3>
            @if(pieChartData?.chartData?.length > 0) {
            <div class="w-full h-[450px] pt-12 flex justify-center">
              <app-pie-chart [data]="$safeNavigationMigration(pieChartData?.chartData)" [showLabelsOnHover]="false" [legendPosition]="'bottom'"
                [width]="300" [height]="300" [useParentHeight]="false" [showLegendValues]="false"
                [keepLabelsOnHover]="true" [tightViewBox]="true">
              </app-pie-chart>
            </div>
            } @else {
            <div class="flex flex-col items-center justify-center h-[300px] text-gray-500">
              <app-icon name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon>
              <p class="text-lg font-medium">No data available</p>
              <p class="text-sm mt-1">Data will appear here when available</p>
            </div>
            }
            @if(isSectionLoading('contractTypes')){
            <app-individual-toaster></app-individual-toaster>
            }
            }

            <!-- Top 10 Businesses by Contracts (Bar Chart) -->
            @case (CardId.TOP_BUSINESSES_BY_CONTRACTS) {
            <div class="flex flex-col items-start gap-3 mb-4">
              <h3 class="text-xl font-normal text-[#141437] dark:text-white">
                Top 10 Businesses by Contracts
              </h3>
              <div class="text-[#7D7D93] dark:text-ink-muted text-sm">No. of Contracts</div>
            </div>
            <div class="w-full h-[400px]">
              @if(businessWiseContractChartData?.chartData?.length > 0) {
              <app-single-bar [data1]="$safeNavigationMigration(businessWiseContractChartData?.chartData)" [rotateLabel]="true"
                [valueKey]="'value'" [valueType]="'%'" [colors]="colors" [barTextposition]="'center'"
                [showBarValue]="false" [labelKey]="'month_short'" [barWidthScale]="barWidthScale()">
              </app-single-bar>
              } @else {
              <div class="flex flex-col items-center justify-center h-full text-gray-500">
                <app-icon name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon>
                <p class="text-lg font-medium">No data available</p>
                <p class="text-sm mt-1">Data will appear here when available</p>
              </div>
              }
            </div>
            @if(isSectionLoading('businessWiseContract')){
            <app-individual-toaster></app-individual-toaster>
            }
            }

            <!-- Business & Contracts Overall Table -->
            @case (CardId.BUSINESS_CONTRACT_TABLE) {
            <div class="flex justify-between items-center mb-4">
              <h3 class="text-xl font-normal text-[#141437] dark:text-white">
                {{ viewBusinessContactType == "summaryView" ? "Businesses wise Contract Created" : "Overall Business
                Detail" }}
              </h3>
              <div class="flex items-center gap-2">
                <app-toggle-btns [headerOptions]="{
                          showlabels: true,
                          showTable: true,
                          showIcon: true,
                          showToggleButton: true,
                          toggleOptions: businessWiseContractTabOptions
                        }" (viewChanged)="setBusinessWiseContactChartActiveTab($event)">
                </app-toggle-btns>
              </div>
            </div>
            <div class="overflow-hidden">
              @if(viewBusinessContactType == 'summaryView' && businessWiseContractSignal().length){
              <app-paginated-table [tableData]="businessWiseContractSignal()"
                [headers]="createTableHeaders(businessWiseContractSignal())" [isCheckboxShow]="false">
              </app-paginated-table>
              }
              @if(viewBusinessContactType == 'detailedView'){
              <app-paginated-table [tableData]="overallBusinessContractSignal()"
                [headers]="createTableHeaders(overallBusinessContractSignal())" [isCheckboxShow]="false"
                [tableKey]="'detailedView'">
              </app-paginated-table>
              }
            </div>
            @if(isSectionLoading('businessWiseContract') || isSectionLoading('overallBusinessContract')){
            <app-individual-toaster></app-individual-toaster>
            }
            }

            }
          </div>
        </div>
        }

      </div>
      }
    </div>
  </div>
  <!-- Mobile Section -->
  <div class="bg-white dark:bg-surface-1" [class.hidden]="_breakpointService.isDesktop()"
    [class.pb-24]="!mobileDetailedView()" [ngClass]="{ 'dark:bg-indigo-600/20': !_breakpointService.isMobile() }">
    <!-- <div class="block lg:hidden bg-white dark:bg-surface-1 min-h-screen" [class.pb-24]="!mobileDetailedView()"> -->
    <app-monthly-report-mobile [isLoading]="isDashboardLoading()" [startDate]="startDate()" [endDate]="endDate()"
      [activeBusiness]="activeBusiness" [maxActiveBusinessValue]="maxActiveBusinessValue"
      [podiumConfig]="podiumConfig()" [categoryPodiumConfig]="categoryPodiumConfig()"
      [enrolledCurrent]="enrolledCurrent()" [enrolledGrowth]="enrolledGrowth()" [contractsCurrent]="contractsCurrent()"
      [contractsGrowth]="contractsGrowth()" [businessContractTypes]="businessContractTypes"
      [fullEnrolledBusinessList]="fullEnrolledBusinessList()" [fullRegionalContractsList]="fullRegionalContractsList()"
      [fullCategoryList]="fullCategoryList()" [overallContractsList]="overallContractsList()"
      [overallContractsTotal]="overallContractsTotal()" [remainingTopBusinesses]="remainingTopBusinesses()"
      [mobileDetailedView]="mobileDetailedView()" [mobileChartType]="mobileChartType()"
      [enrolledSearchQuery]="enrolledSearchQuery()" [contractsSearchQuery]="contractsSearchQuery()" [unit]="unit()"
      (filterRequested)="openFilterSheet()" (aiRequested)="openAiBottomSheet()"
      (detailOpened)="openMobileDetail($event)" (detailClosed)="closeMobileDetail()"
      (chartTypeChanged)="setMobileChartType($event)" (enrolledSearchQueryChanged)="enrolledSearchQuery.set($event)"
      (contractsSearchQueryChanged)="contractsSearchQuery.set($event)">
    </app-monthly-report-mobile>

  </div>

  <!--  Customize Popup Layout — Mini-Dashboard Editor Inline overlay that visually mirrors the actual dashboard structure. Each tile takes the same proportional width as its real-dashboard counterpart and supports drag-drop reordering, width resizing, and visibility toggling — like a true layout builder.  -->
  <!-- ═════════════════════════════════════════════════════════════════════════ -->
  @if (isLayoutEditorOpen()) {
  <!-- z-[10000] sits above the global navbar/sidebar (which use z-[999]) so the popup never gets clipped by the dashboard header. Extra top padding gives breathing room from the page top. -->
  <div
    class="fixed inset-0 z-[10000] flex items-start sm:items-center justify-center p-3 pt-20 sm:pt-10 sm:p-6 bg-slate-900/60 backdrop-blur-sm animate-fadeIn overflow-y-auto"
    (click)="closeLayoutEditor()">

    <div
      class="layout-editor-popup relative w-full max-w-[1100px] max-h-[calc(100vh-6rem)] sm:max-h-[88vh] flex flex-col bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-700 overflow-hidden my-auto"
      (click)="$event.stopPropagation()">

      <!--  Header -->
      <div
        class="flex flex-wrap items-center justify-between gap-3 px-5 sm:px-6 py-4 border-b border-slate-200 dark:border-slate-700 bg-gradient-to-r from-[#AD46FF]/5 via-white to-[#AD46FF]/5 dark:from-purple-500/10 dark:via-slate-900 dark:to-purple-500/10">
        <div class="flex items-center gap-3 min-w-0">
          <div
            class="w-10 h-10 rounded-xl bg-gradient-to-br from-[#AD46FF] to-[#7c3aed] flex items-center justify-center shadow-lg shadow-[#AD46FF]/30 shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <rect width="7" height="9" x="3" y="3" rx="1" />
              <rect width="7" height="5" x="14" y="3" rx="1" />
              <rect width="7" height="9" x="14" y="12" rx="1" />
              <rect width="7" height="5" x="3" y="16" rx="1" />
            </svg>
          </div>
          <div class="min-w-0">
            <h2 class="text-lg sm:text-xl font-semibold text-[#141437] dark:text-white truncate">
              Customize Layout
            </h2>
            <p class="text-[11px] text-violet-700 dark:text-violet-300">
              <b>Drag</b> a card to reorder &middot; click the <b>width chips</b> to resize &middot; toggle the
              <b>eye</b> to hide/show &middot; the preview mirrors the real dashboard.
            </p>
          </div>
        </div>

        <div class="flex items-center gap-2.5 flex-wrap">
          <!-- Auto Adjust Width: expands the smallest card in each row of
                 the preview so any leftover columns are filled (e.g. a row
                 with 6 + 4 grows the col-4 card to col-6 → row sums to 12). -->
          <button type="button" (click)="autoAdjustEditorWidths()" [disabled]="!canAutoAdjustEditorWidths()"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all"
            [ngClass]="canAutoAdjustEditorWidths()
                ? 'bg-white dark:bg-slate-800 text-[#AD46FF] border border-[#AD46FF]/30 hover:bg-violet-50 dark:hover:bg-white/5 hover:border-[#AD46FF]/60 shadow-sm cursor-pointer'
                : 'bg-slate-50 dark:bg-slate-800 text-slate-400 dark:text-slate-500 border border-slate-200 dark:border-slate-700 cursor-not-allowed'"
            title="Expand the smallest card in each row to fill the leftover columns">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="15 3 21 3 21 9" />
              <polyline points="9 21 3 21 3 15" />
              <line x1="21" y1="3" x2="14" y2="10" />
              <line x1="3" y1="21" x2="10" y2="14" />
            </svg>
            Auto Adjust Width
          </button>

          <!-- Visible count chip -->
          <span
            class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-violet-50 dark:bg-violet-500/10 text-[#AD46FF] border border-[#AD46FF]/20">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
            {{ editorVisibleCount() }} / {{ editorItems().length }} visible
          </span>

          <!-- Close -->
          <button type="button" (click)="closeLayoutEditor()"
            class="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
            title="Close">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Layout Preview Area (mini dashboard editor) -->
      <div class="flex-1 overflow-y-auto custom-scroll bg-[#FAFAFE] dark:bg-slate-950/40 p-3 sm:p-4">

        <!-- 12-col mini grid -->
        <div cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="onEditorCardDrop($event)"
          class="grid grid-cols-12 gap-2 sm:gap-2.5 grid-flow-row-dense">

          @for (item of editorItems(); track trackEditorItem($index, item)) {
          <div cdkDrag cdkDragBoundary=".layout-editor-popup" [cdkDragData]="item" [cdkDragDisabled]="!item.visible"
            [ngClass]="[
                  getEditorColSpanClass(item.colSpan),
                  isTallEditorTile(item) ? 'row-span-2' : '',
                  item.visible
                    ? 'border-slate-200 dark:border-slate-700 shadow-sm hover:shadow-lg hover:-translate-y-0.5 hover:border-[#AD46FF]/40 cursor-grab active:cursor-grabbing'
                    : 'border-dashed border-slate-300 dark:border-slate-600 opacity-60 cursor-not-allowed'
                ]"
            class="layout-editor-tile group relative rounded-xl border bg-white dark:bg-slate-800 transition-all duration-200 overflow-hidden">

            <!-- Drop placeholder (highlight slot during drag) -->
            <div *cdkDragPlaceholder [ngClass]="[
                    getEditorColSpanClass(item.colSpan),
                    isTallEditorTile(item) ? 'row-span-2' : ''
                  ]"
              class="rounded-xl border-2 border-dashed border-[#AD46FF]/60 bg-violet-50 dark:bg-violet-500/10 min-h-[88px]">
            </div>

            <!-- Tile header: drag handle + title + actions -->
            <div class="flex items-start justify-between gap-2 px-2.5 pt-2 pb-1">
              <div class="flex items-center gap-1.5 min-w-0">
                <span class="text-slate-300 dark:text-slate-600 group-hover:text-[#AD46FF] transition-colors shrink-0"
                  title="Drag to reorder">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="9" cy="5" r="1" fill="currentColor" stroke="none" />
                    <circle cx="9" cy="12" r="1" fill="currentColor" stroke="none" />
                    <circle cx="9" cy="19" r="1" fill="currentColor" stroke="none" />
                    <circle cx="15" cy="5" r="1" fill="currentColor" stroke="none" />
                    <circle cx="15" cy="12" r="1" fill="currentColor" stroke="none" />
                    <circle cx="15" cy="19" r="1" fill="currentColor" stroke="none" />
                  </svg>
                </span>
                <span class="text-[11px] sm:text-[12px] font-semibold text-[#141437] dark:text-white truncate"
                  [title]="item.title">
                  {{ item.title }}
                </span>
              </div>

              <!-- Visibility toggle -->
              <button type="button" (click)="toggleEditorCardVisibility(item.id); $event.stopPropagation()"
                class="p-1 rounded-md transition-colors shrink-0"
                [ngClass]="item.visible
                      ? 'text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                      : 'text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700'"
                [title]="item.visible ? 'Hide section' : 'Show section'">
                @if (item.visible) {
                <app-icon-v2 name="eye" [size]="14"></app-icon-v2>
                } @else {
                <app-icon-v2 name="eye-off" [size]="14"></app-icon-v2>
                }
              </button>
            </div>

            <!-- Tile body: scaled-down preview placeholder + width chips -->
            <div class="px-2.5 pb-2">
              <div
                class="rounded-lg bg-gradient-to-br from-violet-50 via-white to-violet-50/50 dark:from-violet-500/10 dark:via-slate-800 dark:to-violet-500/5 border border-slate-100 dark:border-slate-700/50 h-10 sm:h-10 flex items-center justify-center mb-1.5 overflow-hidden relative">
                <!-- abstract preview bars -->
                <div class="flex items-end gap-1 w-2/3 h-1/2 opacity-70">
                  <span class="flex-1 bg-[#AD46FF]/30 rounded-sm" style="height: 40%"></span>
                  <span class="flex-1 bg-[#AD46FF]/50 rounded-sm" style="height: 70%"></span>
                  <span class="flex-1 bg-[#AD46FF]/40 rounded-sm" style="height: 55%"></span>
                  <span class="flex-1 bg-[#AD46FF]/60 rounded-sm" style="height: 90%"></span>
                  <span class="flex-1 bg-[#AD46FF]/35 rounded-sm" style="height: 50%"></span>
                  <span class="flex-1 bg-[#AD46FF]/55 rounded-sm" style="height: 80%"></span>
                </div>
                <span
                  class="absolute top-0.5 right-1 text-[9px] font-semibold text-[#AD46FF]/70 uppercase tracking-wider">
                  {{ item.colSpan }}/12
                </span>
              </div>

              <!-- Width selector — minimize-2 / maximize-2 icon buttons step
                       the card through [4 → 6 → 8 → 12] widths.
                       Buttons disable themselves at the boundary. -->
              <div class="flex items-center gap-1.5">
                <span
                  class="text-[10px] font-medium text-slate-400 dark:text-slate-500 uppercase tracking-wide mr-0.5">Width</span>

                <!-- Decrease (minimize-2) -->
                <button type="button" (click)="decreaseEditorCardColSpan(item.id); $event.stopPropagation()"
                  [disabled]="!canDecreaseEditorCardColSpan(item)" class="p-1 rounded-md border transition-all"
                  [ngClass]="canDecreaseEditorCardColSpan(item)
                        ? 'bg-white dark:bg-slate-700 text-slate-500 dark:text-slate-300 border-slate-200 dark:border-slate-600 hover:border-[#AD46FF]/50 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                        : 'bg-slate-50 dark:bg-slate-800 text-slate-300 dark:text-slate-600 border-slate-100 dark:border-slate-700 cursor-not-allowed'"
                  title="Decrease width">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="4 14 10 14 10 20" />
                    <polyline points="20 10 14 10 14 4" />
                    <line x1="14" y1="10" x2="21" y2="3" />
                    <line x1="3" y1="21" x2="10" y2="14" />
                  </svg>
                </button>

                <!-- Current width pill — Small / Medium / Large / Full -->
                <span
                  class="inline-flex items-center justify-center min-w-[58px] h-[20px] px-2 rounded-md text-[10px] font-semibold bg-[#AD46FF]/10 text-[#AD46FF] border border-[#AD46FF]/20 select-none whitespace-nowrap">
                  {{ getEditorColSpanLabel(item.colSpan) }}
                </span>

                <!-- Increase (maximize-2) -->
                <button type="button" (click)="increaseEditorCardColSpan(item.id); $event.stopPropagation()"
                  [disabled]="!canIncreaseEditorCardColSpan(item)" class="p-1 rounded-md border transition-all"
                  [ngClass]="canIncreaseEditorCardColSpan(item)
                        ? 'bg-white dark:bg-slate-700 text-slate-500 dark:text-slate-300 border-slate-200 dark:border-slate-600 hover:border-[#AD46FF]/50 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                        : 'bg-slate-50 dark:bg-slate-800 text-slate-300 dark:text-slate-600 border-slate-100 dark:border-slate-700 cursor-not-allowed'"
                  title="Increase width">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 3 21 3 21 9" />
                    <polyline points="9 21 3 21 3 15" />
                    <line x1="21" y1="3" x2="14" y2="10" />
                    <line x1="3" y1="21" x2="10" y2="14" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          }
        </div>

        @if (editorItems().length === 0) {
        <div class="text-center py-16 text-slate-500 dark:text-slate-400">
          <p class="text-sm">No layout items to customize.</p>
        </div>
        }
      </div>

      <!-- ▶ Footer -->
      <div
        class="flex items-center justify-between gap-3 px-5 sm:px-6 py-3.5 border-t border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900">
        <button type="button" (click)="resetLayoutEditorToDefaults()"
          class="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium text-slate-600 dark:text-slate-300 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5 transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
            <path d="M3 3v5h5" />
          </svg>
          Set Default
        </button>

        <div class="flex items-center gap-2">
          <button type="button" (click)="closeLayoutEditor()"
            class="px-4 py-2 rounded-lg text-sm font-medium text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors">
            Cancel
          </button>
          <button type="button" (click)="applyLayoutEditor()" [disabled]="editorVisibleCount() === 0"
            class="px-5 py-2 rounded-lg text-sm font-semibold text-white bg-gradient-to-r from-[#AD46FF] to-[#7c3aed] hover:shadow-lg hover:shadow-[#AD46FF]/30 hover:-translate-y-px disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0 transition-all">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
  }
</ng-container>